import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "sidebar"];

  toggleSidebar() {
    this.buttonTarget.classList.toggle("dashboard__sidebar--toggle-button--shrink");
    this.sidebarTarget.classList.toggle("dashboard__sidebar--shrink");
  }
}
